module.exports = new __parcel__URL__("shop_machines_bp_star_wolvez_helmet_cosmetic.0247994d.png").toString();